import { useEffect } from "react";
import { io } from "socket.io-client";

const SOCKET_URL = (
  process.env.REACT_APP_API_URL || "http://localhost:4000/api"
).replace(/\/api\/?$/, "");

// Connects anonymous (non-logged-in) users to the socket so the admin panel
// can count how many visitors are browsing without an account.
export default function AnonymousPresence() {
  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") || localStorage.getItem("token");
    if (token) return; // Authenticated users connect via their own components

    const socket = io(SOCKET_URL, { transports: ["websocket"] });
    return () => socket.disconnect();
  }, []);

  return null;
}
